import { isLogged } from "../customer";
import {isCartStep} from "../functions";

export const Layout = function (content, count) {
	var steps = '';
	if (isLogged() && count > 0) {
		steps = `<div id="order-steps" class="table-cell-grid shoptet-clearfix">
               <div id="os1" class="order-step-single ${isCartStep(1) ? 'active' : ''}" data-testid="step1">
                  1. Nákupní košík
                  <span class="order-step-decor">&nbsp;</span>
               </div>
               <div id="os2" class="order-step-single ${isCartStep(2) ? 'active' : ''}" data-testid="step2">
                  2. Platba a doprava
                  <span class="order-step-decor">&nbsp;</span>
               </div>
               <div id="os3" class="order-step-single ${isCartStep(3) ? 'active' : ''}" data-testid="step3">
                  3. Informace o&nbsp;vás
                  <span class="order-step-decor">&nbsp;</span>
               </div>
               <div id="os4" class="order-step-single last ${isCartStep(4) ? 'active' : ''}" data-testid="step4">
                  4. Dokončení předplatného
               </div>
            </div>`;
	}
	return `<div id="main-ina" class="large-12 medium-12 small-12 columns">
   <div id="main-in-in" class="large-12 medium-12 small-12" style="display: block">
      <div id="content" class="large-12 medium-12 small-12 row">
         <main id="content-in" class="large-12 medium-12 small-12 columns">
            ${steps}
            
            <h1 style="font-size: 25px; color: black">Předplatné</h1>
            
            ${content}
         </main>
      </div>
   </div>
</div>`;
}